export default __webpack_public_path__ + "static/media/logo-empty.c870788c.png";